import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, Renderer, Renderer2 } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DealsWizardModel, DealServiceItemModel, ServiceTypeModel } from '../../../_models/_index';
import { GeneralService, UserService, DealService } from '../../../services/_index';
import { DealStepEnum, ViewModeEnum, AlertDialogTypeEnum  } from '../../../_enums/_index';
import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectChange } from '@angular/material/select';


@Component({
    selector: 'deal-package',
    moduleId: module.id,
    templateUrl: 'deal-package.component.html'
})

export class DealPackageComponent implements OnInit {
    @Input()
    dealsWizard: DealsWizardModel;

    @Input()
    dealStep: DealStepEnum;

    @Output()
    private nextStepEvent: EventEmitter<DealStepEnum>;

    @ViewChild('packageApprovedCB')
    approveCB: ElementRef;

    @ViewChild('saturdayService')
    saturdayCB: ElementRef;

    @Input()
    serviceTypeList: ServiceTypeModel[];

    @Output()
    private typeChangedEvent: EventEmitter<number>;

    //@Input()
    //selected2: ServiceTypeModel;

    constructor(private dialog: MatDialog,
        private generalService: GeneralService,
        private userService: UserService,
        private renderer: Renderer,
        private dealService: DealService,
        private renderer2 : Renderer2
    ) {
        this.nextStepEvent = new EventEmitter<DealStepEnum>();
        this.typeChangedEvent = new EventEmitter<number>();
    }

    ngOnChanges() {

    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    nextStep() {
        if (this.userService.isCustomer() && !this.dealsWizard.packageApproved)
        {
            this.generalService.showErrorDialog('חובה לאשר את תוכן החבילה');
            this.renderer.invokeElementMethod(this.approveCB, 'focus', []);
        }
        else {
           
            this.dealStep++;
            this.nextStepEvent.emit(this.dealStep);
        }
    }   

    ngOnInit() { 
             
    }



    canEditPackage()
    {
        let result = true;
        if (this.userService.isCustomer()) {
                result = false;
        }
        else if (this.dealsWizard.statusID > 3)
            result = false;

        return result;
    }

    typeChange() {
        debugger;
        this.typeChangedEvent.emit(this.dealsWizard.serviceTypeID);

        //this.dealService.getDealByID(this.dealsWizard.id, this.dealsWizard.serviceTypeID)
        //    .then(result => {debugger;
        //        if (result != null) {
        //            var temp = this.dealsWizard.serviceTypeID;

        //            this.dealsWizard = result;
        //            this.dealsWizard.serviceTypeID = temp;
                   
        //        }
        //    });
    }
    onSaturdayServiceCheck(ob: MatCheckboxChange) {
        if (ob.checked) {
            this.dealsWizard.saturdayService = true
            const saturday = new DealServiceItemModel()
            // saturday.dealID = this.dealsWizard.dealServiceItems[this.dealsWizard.dealServiceItems.length -1].id +1
            saturday.description = "תוספת מענה בשבת"
            saturday.price = 30
            saturday.remark = 'עלות חודשית בש"ח לא כולל מע"מ'
            saturday.id = this.dealsWizard.dealServiceItems.length
            this.dealsWizard.dealServiceItems.push(saturday)
            
           // this.renderer2.selectRootElement('#saturdayService').scrollIntoView()
  
        } else {
            this.dealsWizard.dealServiceItems.pop()
            this.dealsWizard.saturdayService = false
           // this.renderer2.selectRootElement('#saturdayService').scrollIntoView()
  
        }
        console.log(this.dealsWizard.dealServiceItems)
        setTimeout(() => {
            // I'm assuming here that 'this.approveCB' is a valid reference to a DOM element in your component.
            this.renderer.invokeElementMethod(this.approveCB, 'focus', []);
        }, 100);
    }

    onSaturdayServiceCheck1(event: MatSelectChange) {
        debugger;

        if (event.value === true) {
            this.dealsWizard.saturdayService = true;
            const saturday = new DealServiceItemModel();
            saturday.description = "תוספת מענה בשבת";
            saturday.price = 30;
            saturday.remark = 'עלות חודשית בש"ח לא כולל מע"מ';
            saturday.id = this.dealsWizard.dealServiceItems.length;
            this.dealsWizard.dealServiceItems.push(saturday);
        } else if (event.value === false && this.dealsWizard.dealServiceItems[this.dealsWizard.dealServiceItems.length - 1].description === "תוספת מענה בשבת") {
            this.dealsWizard.dealServiceItems.pop();
            this.dealsWizard.saturdayService = false;
        }

        console.log(this.dealsWizard.dealServiceItems);
        setTimeout(() => {
            // Assuming here that 'this.approveCB' is a valid reference to a DOM element in your component.
            this.renderer.invokeElementMethod(this.approveCB, 'focus', []);
        }, 100);
    }

    
}


// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-package/deal-package.component.ts